/**
 * fn will be called when the DOM is ready
 * @param {Function} fn
 */
export function ready(fn) {
    if (document.readyState !== 'loading') {
        fn();
    }
    else {
        document.addEventListener('DOMContentLoaded', () => fn());
    }
}
/**
 * Returns a promise that resolves when the DOM is ready
 * @returns {Promise<void>}
 */
export function whenReady() {
    return new Promise(function (resolve) {
        ready(resolve);
    });
}
/**
 * Adds an event listener to an element and returns a function that removes the event listener
 * @param {HTMLElement} element - the element to add the event listener to
 * @param {string} eventType - the event type to listen for
 * @param {EventListenerOrEventListenerObject} handler - the event handler
 * @returns {Function} - function that removes the event listener
 */
export function addEventListener(element, eventType, handler, options) {
    element.addEventListener(eventType, handler, options);
    return () => {
        element.removeEventListener(eventType, handler, options);
    };
}
//# sourceMappingURL=dom-utils.js.map